import type {
  AssetTypeTemplateSelectOptionItemData,
  AssetTypeTemplateSelectOptionItemValue,
  AssetTypeTemplateSelectProps,
} from "./asset-type-template-select.type";

import { useTranslation } from "react-i18next";

import ModelSelectOption from "@/components/Elements/ModelSelectOption";
import QueryableSelect from "@/modules/queryable-select";

const AssetTypeTemplateSelect = ({
  hideLabel,
  ...props
}: AssetTypeTemplateSelectProps) => {
  const { t } = useTranslation();
  const label = t("global:technicalForm");

  return (
    <QueryableSelect<
      AssetTypeTemplateSelectOptionItemValue,
      AssetTypeTemplateSelectOptionItemData
    >
      data-testid="asset-type-template-select"
      name="entityTemplate"
      model="entityTemplates"
      filterBy="name"
      fields={["id", "name"]}
      label={hideLabel ? undefined : label}
      placeholder={label}
      optionFormat={ModelSelectOption}
      {...props}
    />
  );
};

export default AssetTypeTemplateSelect;
